// Ian - robust hidden-variants.js for Envy theme
// Hides individual variants, dropdown options, and color swatches if all variants are hidden
document.addEventListener('DOMContentLoaded', function() {
  var wrappers = document.querySelectorAll('[data-hidden-variant-ids]');

  wrappers.forEach(function(root) {
    var hiddenIds = (root.getAttribute('data-hidden-variant-ids') || '').split(',').map(Number);

    function hideVariants() {
      // 1. Hide individual variant swatches
      root.querySelectorAll('input[type=radio][data-option-value-id]').forEach(function(input) {
        var variantId = Number(input.getAttribute('data-option-value-id'));
        if (hiddenIds.includes(variantId)) {
          input.closest('.swatch-element').style.display = 'none';
          input.checked = false;
        } else {
          input.closest('.swatch-element').style.display = '';
        }
      });

      // 2. Hide color swatches if all variants of that color are hidden
      var colors = Array.from(new Set(Array.from(root.querySelectorAll('input[type=radio][data-option-value-id]'))
        .map(input => input.closest('.swatch-element').getAttribute('data-value'))));

      colors.forEach(function(color) {
        var inputsForColor = Array.from(root.querySelectorAll('input[type=radio][data-option-value-id]'))
          .filter(input => input.closest('.swatch-element').getAttribute('data-value') === color);

        var allHidden = inputsForColor.every(input => hiddenIds.includes(Number(input.getAttribute('data-option-value-id'))));

        // Hide each swatch element for that color if all variants hidden
        inputsForColor.forEach(input => {
          var swatchEl = input.closest('.swatch-element.color');
          if (swatchEl && allHidden) swatchEl.style.display = 'none';
        });
      });

      // 3. Hide dropdown options
      root.querySelectorAll('select option').forEach(function(opt) {
        var variantId = Number(opt.dataset.variantId || opt.value);
        if (hiddenIds.includes(variantId)) {
          opt.hidden = true;
          if (opt.selected) opt.selected = false;
        } else {
          opt.hidden = false;
        }
      });

      // 4. Uncheck any active input that is hidden
      var activeInput = root.querySelector('input[type=radio]:checked');
      if (activeInput && hiddenIds.includes(Number(activeInput.getAttribute('data-option-value-id')))) {
        activeInput.checked = false;
      }
    }

    hideVariants();
    root.addEventListener('change', hideVariants);
  });
});